import { render, staticRenderFns } from "./task_time.vue?vue&type=template&id=bedd452c&scoped=true&"
import script from "./task_time.vue?vue&type=script&lang=js&"
export * from "./task_time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedd452c",
  null
  
)

export default component.exports